.pop {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  z-index: 1;
  margin-bottom: var(--spacing-8);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  padding: var(--spacing-12);
  background: var(--bg-secondary);
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-12);
  box-shadow: var(--shadow-l);
  max-width: 280px;
}

.preview {
  margin: 0;
  max-height: 64px;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  font: var(--text-micro-regular);
  color: var(--text-secondary);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-8);
}
